import { Flex, Grid, Text } from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { CreatorGender } from '~/clientApi/creator.model';
import { genders } from '~/components/TalentRosterGenderTag';

import { useCreatorsFiltersStore } from '../../store/useCreatorsFiltersStore';
import { SelectButton } from './SelectButton';

interface GenderFiltersProps {}

export function GenderFilters({}: GenderFiltersProps) {
  const { gender: selectedGender, setGender } = useCreatorsFiltersStore();

  const handleSelectGender = useCallback(
    (gender: CreatorGender) => {
      setGender(gender);
    },
    [setGender],
  );

  return (
    <Flex flexDirection="column" gap={2}>
      <Text fontSize="lg" fontWeight="500" color="primary.500">
        Select Gender
      </Text>
      <Grid templateColumns="repeat(3, 1fr)" gap={2}>
        {genders.map((gender) => {
          const isSelected = selectedGender === gender;

          return (
            <SelectButton
              key={gender}
              value={gender}
              isSelected={isSelected}
              onSelect={handleSelectGender}
            />
          );
        })}
      </Grid>
    </Flex>
  );
}
